import { Box, formatPhoneNumber, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { BulkSelected } from "components";
import {
  BulkSelectedItemErrors,
  PersonDto,
  TextingOptInDto,
} from "generated/openApi";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";

export const SelectedPersons = (props: {
  optInNumbers: TextingOptInDto[];
  persons: Map<string, PersonDto>;
  setPersons: (value: Map<string, PersonDto>) => void;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef } = useElementBreakpoints();

  const isPersonOptedIn = (person: PersonDto) => {
    return props.optInNumbers.some((number) => {
      if (number.phoneNumber && person.cellPhone && number.phoneNumber === person.cellPhone) {
        return true;
      }

      if (person.isParent) {
        return number.isParent && number.parentId === person.id;
      }

      return !number.isParent && (number.studentId === person.id || number.customId1 === person.identification);
    });
  };

  const getItemLabel = (person: PersonDto) => (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing="sm">
      {person.isParent && (<EscalatorWarningIcon />)}
      <Stack>
        {person.cellPhone && (
          <>
            <Typography>
              {person.lastName}, {person.firstName} ({person.identification})
            </Typography>
            <Typography variant="caption" lineHeight="100%">
              {formatPhoneNumber(person.cellPhone)}
            </Typography>
            {isPersonOptedIn(person) && (
              <Typography variant="caption" lineHeight="100%" color="green">
                Opted-In
              </Typography>
            )}
            {!isPersonOptedIn(person) && (
              <Typography variant="caption" lineHeight="100%" color="orange">
                Not Opted-In
              </Typography>
            )}
          </>
        )}
        {!person.cellPhone && (
          <>
            <Typography color="error">
              {person.lastName}, {person.firstName} ({person.identification})
            </Typography>
            <Typography variant="caption" lineHeight="100%" color="error">
              No valid cell phone number.
            </Typography>
          </>
        )}
        {person.isUnder13 && (
          <Typography variant="caption" lineHeight="100%" color="error">
            Person is under 13 years old
          </Typography>
        )}
      </Stack>
    </Stack>
  );

  return (
    <>
      {(props.optInNumbers && props.optInNumbers.length > 0) && (
        <Box ref={breakpointsRef}>
          <BulkSelected
            label="Person"
            items={props.persons || []}
            setItems={(value) => props.setPersons(value)}
            getItemLabel={getItemLabel}
            errors={props.errors}
            setErrors={props.setErrors}
          />
        </Box>
      )}
    </>
  );
};
